import api from "../../utils/ApiConfig";

export const fetchActivite = async (segment = null, search = null, filters = {}) => {
  const params = new URLSearchParams();
  if (segment) params.set("segment", segment);
  if (search)  params.set("search", search);
  if (filters.tag)        params.set("tag", filters.tag);
  if (filters.typeClient) params.set("type_client", filters.typeClient);
  if (filters.ville)      params.set("ville", filters.ville);
  if (filters.volume)     params.set("volume", filters.volume);
  const response = await api.get(`/bo/clients/activite?${params}`);
  return response.data;
};

export const updateProfilCommercial = async (userId, data) => {
  const response = await api.patch(`/bo/clients/${userId}/profil-commercial`, data);
  return response.data;
};

export const addClientTag = async (userId, tag) => {
  const response = await api.post(`/bo/clients/${userId}/tags`, { tag });
  return response.data;
};

export const removeClientTag = async (userId, tagId) => {
  const response = await api.delete(`/bo/clients/${userId}/tags/${tagId}`);
  return response.data;
};

export const fetchClientTags = async () => {
  const response = await api.get(`/bo/clients/tags`);
  return response.data;
};

export const fetchClientVilles = async () => {
  const response = await api.get(`/bo/clients/villes`);
  return response.data;
};
